import React, { useState, useEffect } from "react";
import moment from "moment";
import { DatePicker } from "react-advance-jalaali-datepicker";
import ExportJsonExcel from "js-export-excel";
import { useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import helpersTime from "../../../../../helpers/time";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import messagesSitePublishers from "../../../../../messages/category-user-site-publishers";
import Pagination from "../../../../partials/content/Pagination";

export default function AddAllCategorySitePublisherViaCategorySubject() {
  const [message, setMessage] = useState();
  const [reportStatePositions, setReportStatePositions] = useState();
  const [
    categorySitePublisherIDSSelected,
    setCategorySitePublisherIDSSelected,
  ] = useState([]);
  // const [allCategorySitePublisher, setAllCategorySitePublisher] = useState([]);

  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();
  const [categoryIDSearchFilter, setCategoryIDSearchFilter] = useState();

  let startDate = moment(helpersTime.getDateNow())
    .add(1, "days")
    .format("YYYY/M/D");
  let endDate = moment(helpersTime.getDateNow())
    .add(2, "days")
    .format("YYYY/M/D");

  const history = useHistory();

  useEffect(() => {
    getCategoriesSitePublisher();
  }, [currentPage, categoryNameSearchFilter, categoryIDSearchFilter]);

  const getCategoriesSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultRequestGetCategories =
      await sendRequestGetAllCategorySitePublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultRequestGetCategories) {
      return;
    }

    setCategories(resultRequestGetCategories.category_site_publisher);
    setCountPage(resultRequestGetCategories.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (categoryNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${categoryNameSearchFilter}`;
    }
    if (categoryIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${categoryIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };
  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const sendRequestGetAllCategorySitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let allCategorySitePublisher;
    try {
      allCategorySitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/category-site-publishers/alternative/get-category-site-publishers-with-data?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allCategorySitePublisher.data.data;
  };

  const addCategory = async (e) => {
    e.preventDefault();
    const dataForm = getDataForAddCategory();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddCategoryUserSitePublisher =
      await sendRequestAddCategoryUserSitePublisher(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddCategoryUserSitePublisher) {
      return;
    }
    history.push(
      "/manage/publishers/all-banner-category-site-publisher-alternative"
    );
  };

  const getDataForAddCategory = () => {
    return {
      start_date: helpersTime.convertJalaliToGregorian(
        document.querySelector(".start-date input").value
      ),
      end_date: helpersTime.convertJalaliToGregorian(
        document.querySelector(".end-date input").value
      ),
      name: document.querySelector("#name").value,
      sites: reportStatePositions.empty_positions,
      amount: reportStatePositions.price + "",
    };
  };

  const sendRequestAddCategoryUserSitePublisher = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-user-site-publishers/alternative",
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      goScrollIntoTag("add-group-site-publisher-alternative");
      return false;
    }

    return true;
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherDataParam
  ) => {
    let sitePublisherUrl = sitePublisherDataParam.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherDataParam)
          )
        ),
      },
    ];

    for (const key in sitePublisherDataParam) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherDataParam[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }

    return dataEachSitePublisherExcelFile;
  };

  const generatePageDataReportExportExcel = (pageDataReport) => {
    return [
      {
        one: pageDataReport.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(pageDataReport.price)
        ),
      },
      { ...pageDataReport.positions },
      { one: "", two: "" },
    ];
  };

  const getPriceSitePublisher = (priceSitePublisher) => {
    let pricePage = 0;
    const newSitePublisherData = { ...priceSitePublisher };
    for (const key in newSitePublisherData) {
      if (key === "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getExcelFilePositionsSelected = (positions, fileName, price) => {
    const newDataSitePublisher = { ...positions };
    var option = new Object();
    option.fileName = fileName;

    let priceInReportFile = {};

    if (price > 0) {
      priceInReportFile = {
        one: "مبلغ گروه نمایش دهنده",
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(price)
        ),
      };
    }

    let dataExcelFile = [
      priceInReportFile,
      {
        one: "تاریخ شروع",
        two: helpersNumbers.toPersianNum(
          document.querySelector(".start-date input").value
        ),
        three: "تاریخ پایان",
        four: helpersNumbers.toPersianNum(
          document.querySelector(".end-date input").value
        ),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];

    for (let key in newDataSitePublisher) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(
          newDataSitePublisher[key]
        ),
        {
          one: "=======================",
          two: "=======================",
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generateAllCategorySitePublisherTagHtml = () => {
    return (
      <>
        <hr />
        <div className="row py-2">
          <div className="col-12 col-lg-4">
            <div>
              <label>جستجو در شماره صنفی</label>
            </div>
            <div>
              <input
                onKeyUp={(e) => setCategoryIDSearchFilter(e.target.value)}
                onWheel={(event) => event.currentTarget.blur()}
                className="form-control"
                type="number"
              />
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div>
              <label>جستجو در نام دسته صنفی</label>
            </div>
            <div>
              <input
                onKeyUp={(e) => setCategoryNameSearchFilter(e.target.value)}
                className="form-control"
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="table-responsive py-3">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>نام گروه</td>
                <td>مجموع سایت نمایش دهنده</td>
                <td>مجموع صفحات</td>
                <td>مجموع جایگاه</td>
                <td>انتخاب گروه</td>
              </tr>
            </thead>
            <tbody>
              {categories.map((categorySitePublisher, index) => {
                let isChecked = false;
                if (
                  categorySitePublisherIDSSelected.includes(
                    categorySitePublisher.ID + ""
                  )
                ) {
                  isChecked = true;
                }

                return (
                  <tr key={categorySitePublisher.ID}>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(categorySitePublisher.ID)}
                    </td>
                    <td>{categorySitePublisher.name}</td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          categorySitePublisher.count_site_publisher
                        )
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          categorySitePublisher.count_page
                        )
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        categorySitePublisher.count_position
                      )}
                    </td>
                    <td>
                      <label className="adl-switch">
                        <input
                          type="checkbox"
                          defaultChecked={isChecked}
                          className="category-site-publisher-IDS"
                          value={categorySitePublisher.ID}
                          onChange={(e) => {
                            const checkElement = e.target.checked;
                            const categorySitePublisherID = e.target.value;
                            if (checkElement) {
                              setCategorySitePublisherIDSSelected(
                                (prevState) => {
                                  return [
                                    ...prevState,
                                    categorySitePublisherID,
                                  ];
                                }
                              );
                            } else {
                              setCategorySitePublisherIDSSelected(
                                (prevState) => {
                                  return prevState.filter((value) => {
                                    return value !== categorySitePublisherID;
                                  });
                                }
                              );
                            }
                          }}
                        />
                        <span className="adl-slider round"></span>
                      </label>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForGetReportPositions = getDataForGetReportPositions();
    const resultValidateData = validateData(dataForGetReportPositions);
    if (!resultValidateData.status) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidateData.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      goScrollIntoTag("add-group-site-publisher-alternative");
      return;
    }

    dataForGetReportPositions.start_date = helpersTime.convertJalaliToGregorian(
      dataForGetReportPositions.start_date
    );
    dataForGetReportPositions.end_date = helpersTime.convertJalaliToGregorian(
      dataForGetReportPositions.end_date
    );

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestCheckStatePosition =
      await sendRequestCheckStatePosition(dataForGetReportPositions);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestCheckStatePosition) {
      return;
    }

    setReportStatePositions(resultSendRequestCheckStatePosition);
  };

  const validateData = (dataForGetReportPositions) => {
    if (!checkStartDateEntered(dataForGetReportPositions.start_date)) {
      return {
        status: false,
        message: messagesSitePublishers.START_DATE_IS_PAST_FROM_CURRENT_DATE,
      };
    }
    if (
      !checkEndDateEntered(
        dataForGetReportPositions.end_date,
        dataForGetReportPositions.start_date
      )
    ) {
      return {
        status: false,
        message: messagesSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
      };
    }

    if (categorySitePublisherIDSSelected.length === 0) {
      return {
        status: false,
        message:
          messagesSitePublishers.CATEGORY_SITE_PUBLISHER_IDS_SELECTED_DOSE_NOT_SELECT,
      };
    }

    return {
      status: true,
    };
  };

  const checkStartDateEntered = (startDateEntered) => {
    startDateEntered = helpersTime.convertJalaliToGregorian(startDateEntered);
    if (moment(startDateEntered).diff(startDate, "d") < 0) {
      return false;
    }

    return true;
  };

  const checkEndDateEntered = (endDateEntered, startDateEntered) => {
    endDateEntered = helpersTime.convertJalaliToGregorian(endDateEntered);

    if (moment(endDateEntered).diff(endDate, "d") < 0) {
      return false;
    }

    if (
      moment(endDateEntered).diff(
        moment(helpersTime.convertJalaliToGregorian(startDateEntered)),
        "d"
      ) < 0
    ) {
      return false;
    }

    return true;
  };

  const getDataForGetReportPositions = () => {
    return {
      start_date: document.querySelector(".start-date input").value,
      end_date: document.querySelector(".end-date input").value,
      name: document.querySelector("#name").value,
      category_site_publisher_IDS: categorySitePublisherIDSSelected,
    };
  };

  const sendRequestCheckStatePosition = async (dataForGetReportPositions) => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-user-site-publishers/alternative/check-state-positions",
        dataForGetReportPositions,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اضافه کردن گروه نمایش دهنده بنری جایگزین بوسیله گروه های
                  موضوعی
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div
              className="card-body"
              id="add-group-site-publisher-alternative"
            >
              {messageTag}
              <form onSubmit={sendForm}>
                <div className="form-group">
                  <div className="container-fluid p-0">
                    <div className="row align-items-end">
                      <div className="col-12 col-md-4 pb-3">
                        <div>
                          <label>نام گروه</label>
                        </div>
                        <div>
                          <input className="form-control" id="name" required />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 pb-3">
                        <div>
                          <div>
                            <label>تاریخ شروع</label>
                          </div>
                          <div className="custom-data-picker start-date">
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              preSelected={helpersTime.convertGregorianToJalali(
                                startDate
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 pb-3">
                        <div>
                          <div>
                            <label>تاریخ پایان</label>
                          </div>
                          <div className="custom-data-picker end-date">
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              preSelected={helpersTime.convertGregorianToJalali(
                                endDate
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {categories.length == 0 &&
                    categoryNameSearchFilter == null &&
                    categoryIDSearchFilter == null ? (
                      <></>
                    ) : (
                      generateAllCategorySitePublisherTagHtml()
                    )}
                    <div className="row align-items-end">
                      <button className="btn btn-success">
                        بررسی وضعیت جایگاه های
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div>
                {reportStatePositions && (
                  <>
                    <div className="alert alert-info">
                      <div>
                        <span>
                          <label className="pl-2">
                            تعداد جایگاه های انتخاب شده:
                          </label>
                        </span>
                        <span className="letter-spacing-finance-number">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              reportStatePositions.count_empty_positions
                            )
                          )}
                        </span>
                      </div>

                      <div>
                        <span>
                          <label>
                            مبلغ احتمالی گروه نمایش دهنده جایگزین :{" "}
                          </label>
                        </span>
                        <span className="px-2 letter-spacing-finance-number">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              reportStatePositions.price
                            )
                          )}
                        </span>
                        <span>تومان</span>
                      </div>

                      <div>
                        <span>
                          <label className="pl-2">تعداد جایگاه های پر :</label>
                        </span>
                        <span className="letter-spacing-finance-number">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              reportStatePositions.count_full_positions
                            )
                          )}
                        </span>
                      </div>
                    </div>

                    <div>
                      <span className="pl-2">
                        <span
                          className="btn btn-primary"
                          onClick={() => {
                            getExcelFilePositionsSelected(
                              reportStatePositions.empty_positions,
                              "گزارش سایت ها انتخاب شده",
                              reportStatePositions.price
                            );
                          }}
                        >
                          <span className="pl-2">
                            <i className="fa fa-file-excel"></i>
                          </span>
                          <span>فایل Excel گزارش جایگاه های انتخاب شده</span>
                        </span>
                      </span>

                      <span className="pl-2">
                        <span
                          className="btn btn-danger"
                          onClick={() => {
                            getExcelFilePositionsSelected(
                              reportStatePositions.full_positions,
                              "گزارش سایت ها انتخاب نشده",
                              0
                            );
                          }}
                        >
                          <span className="pl-2">
                            <i className="fa fa-file-excel"></i>
                          </span>
                          <span>فایل Excel گزارش جایگاه های انتخاب نشده</span>
                        </span>
                      </span>
                    </div>

                    <hr />
                    <button onClick={addCategory} className="btn btn-primary">
                      اضافه کردن گروه نمایش دهنده
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
